import { LocalStorageKeys } from '@/constants/LocalStorageKeys';
import ISmartExchangeClaims from '@/models/se/ISmartExchangeClaims';
import SmartExchangeService from '@/services/3.6/SmartExchangeService';
import TheWebEnvConfigService from '@/services/TheWebEnvConfigService';
import { smartExchangeStore } from '@/store';
import theLocalStorageUtils from '@/utils/LocalStorageUtils';

export default {
    /**
     * Gets the smart exchange claims from the store. If one doesn't exist will attempt to
     * fetch it from the service and put it in the store, returning the stored claims.
     * @returns a SmartExchangeClaims object, may be empty if not able to attain one.
     */
    async getClaims(): Promise<ISmartExchangeClaims> {
        let claims = smartExchangeStore.SmartExchangeClaims;
        if (claims && claims.userAccessToken) {
            return claims;
        }

        await fetchAndStoreClaims();

        claims = smartExchangeStore.SmartExchangeClaims;
        return claims;
    },

    /**
     * Non-asynchronous method for getting the current smart exchange claims from the store.
     * Does not attempt to fetch from the service.
     */
    getCurrentClaims(): ISmartExchangeClaims {
        const claims = smartExchangeStore.SmartExchangeClaims;
        return claims;
    }
};

async function fetchAndStoreClaims(): Promise<boolean> {
    const accessToken = theLocalStorageUtils.get(LocalStorageKeys.seAccessToken) ?? '';

    const webEnvConfig = await TheWebEnvConfigService.getInstance().getConfigByHost();
    const service = new SmartExchangeService(webEnvConfig);

    const claims = await service.getClaims(accessToken);
    if (claims) {
        smartExchangeStore.setClaims(claims);
        return true;
    }

    smartExchangeStore.resetClaims();
    return false;
}
